﻿$.fn.dxCtrlBuilderEmailSaisieLink = function custom_dxCtrlBuilderEmailSaisieLink(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailsaisielink dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailSaisieLink(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailSaisieLink = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dxRdb = null
    function mConstruit() {
        container.css("height", ((container.innerHeight() > 0) ? container.innerHeight() + "px" : ""))
        container.empty();

        var ds = option.dataSource
        if (typeof ds == 'undefined') ds = ["Aucun", "Web", "Email", "Tel."]
        mInitTypeLink()

        //$("<div style='padding-top:5px;opacity:0.3;font-size:12px;padding-left:16px;'>Type de lien</div>").appendTo(container)
        dxRdb = $("<div/>").appendTo(container).dxCtrlRadioButton({
            //labelMode: "floating",
            //label: "Type de lien",
            dataSource: ds,
            value: link.typeLink,
            layout: 'horizontal',
            onValueChanged: function (e) {
                link = {
                    typeLink: "Aucun",
                    link: "",
                    adrEmail: "",
                    sujet: "",
                    body: "",
                    tel: ""
                }
                switch (e.value) {
                    case "Aucun":
                        $DivDetailLink.css("display", "none")
                        option.value = "javascript:void(0)"
                        break;
                    case "Web":
                        $DivDetailLink.css("display", "")
                        option.value = "https://"
                        break;
                    case "Email":
                        $DivDetailLink.css("display", "")
                        option.value = "mailto:"
                        break;
                    case "Tel.":
                        $DivDetailLink.css("display", "")
                        option.value = "tel:"
                        break;
                    case "Fichier":
                        $DivDetailLink.css("display", "")
                        option.value = "file:"
                        break;
                }
                mConstruit()
                option.onValueChanged(link)
            }
        }).dxCtrlRadioButton("instance")

        var $DivDetailLink = $("<div style='display:none'/>").appendTo(container)

        $("<br/>").appendTo($DivDetailLink)

        switch (link.typeLink) {
            case "Web":
                $DivDetailLink.css("display", "")
                var $Table = $("<table/>").appendTo($DivDetailLink)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
                var dxTextBoxLink = $("<div/>").appendTo($Td).dxCtrlTextBox({
                    bddCtrl: option.bddCtrl,
                    labelMode: "floating",
                    label: ((typeof option.label == 'undefined') ? "Lien web" : option.label),
                    value: link.link,
                    onValueChanged: function (e) {
                        var lien = ((e.value == null) ? "" : e.value)
                        if (!lien.startsWith("http://") && !lien.startsWith("https://") && !lien.startsWith("ftp://") && !lien.startsWith("ftps://")) {
                            lien = "http://" + lien
                        }
                        link.link = lien
                        option.value = link.link
                        option.onValueChanged(link)
                    }
                }).dxCtrlTextBox("instance")
                var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-boxes",
                    hint: "Choisissez un fichier dans votre box<br/>(Vous pouvez choisir un fichier vidéo dans votre box publique. si le fichier est sur votre machine, il vous suffit de le déposer dans le répertoire public de votre box, puis de le sélectionner)",
                    onClick: function (e) {
                        var pop = $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                            bddCtrl: option.bddCtrl,
                            machine: false,
                            box: true,
                            icone: false,
                            imgInternet: false,
                            docCpt: false,
                            courrier: false,
                            multiple: false,
                            optionBox: {
                                allowRepertoirePublic: true,
                                allowRepertoirePartage: false,
                                allowRepertoireUti: false
                            },
                            onValide: function (lstUrlFile) {
                                if (lstUrlFile.length > 0) {
                                    var fic = new cFichier(option.bddCtrl, lstUrlFile[0])
                                    var url = fic.urlPublicAbsolue()
                                    if (url.length > 0) {
                                        dxTextBoxLink.option("value", url)
                                        //link.link = url
                                        //option.value = link.link
                                        //option.onValueChanged(link)
                                        mNotify("Vous avez inséré un lien sur un document de votre box public", "success", 6000)
                                    }
                                }
                                pop.hide();
                            }
                        }).dxCtrlFileUploaderPopup("instance")
                    }
                })
                if (option.bddCtrl.objCptCli.objetMetier.hasSondage()) {
                    var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        icon: "fas fa-clipboard-question",
                        hint: "Choisissez un sondage et utiliser le lien sur celui-ci",
                        onClick: function (e) {
                            var popupLstSondage = $("<div/>").appendTo("body").dxCtrlPopupBase({
                                position: {
                                    my: "right top",
                                    at: "right top",
                                    of: "body"
                                },
                                width: 650,
                                height: "100%",
                                showTitle: true,
                                showMaximize: true,
                                title: "Choisir un sondage",
                                contentTemplate: function (contentElement) {
                                    $("<div style='width:100%;height:100%;position:relative;'/>").appendTo(contentElement).dxCtrlGridSondage({
                                        bddCtrl: option.bddCtrl,
                                        showBtNew: false,
                                        allowClick: true,
                                        onClickDataGrid: function (container, dataGrid, dataTemplate) {
                                            var idSondage = dataGrid.id
                                            if (idSondage) {
                                                var url = option.bddCtrl.getObjet("sondage", idSondage).objetMetier.mGetUrlLink()
                                                if (url.length > 0) {
                                                    dxTextBoxLink.option("value", url)
                                                    //link.link = url
                                                    //option.value = link.link
                                                    //option.onValueChanged(link)
                                                    mNotify("Vous avez inséré un lien sur un sondage", "success", 6000)
                                                }
                                            }
                                            popupLstSondage.hide()
                                        }
                                    }).dxCtrlGridArticle("instance")
                                }
                            }).dxCtrlPopupBase("instance")
                            popupLstSondage.show();
                        }
                    })
                }
                if (parametre.code_appli == "ppmasc") {
                    var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        icon: "fafa fafa-formulaire",
                        hint: "Choisissez un formulaire et utiliser le lien sur celui-ci",
                        onClick: function (e) {
                            var popupLstFormulaire = $("<div/>").appendTo("body").dxCtrlPopupBase({
                                position: {
                                    my: "right top",
                                    at: "right top",
                                    of: "body"
                                },
                                width: 650,
                                height: "100%",
                                showTitle: true,
                                showMaximize: true,
                                title: "Choisir un formulaire",
                                contentTemplate: function (contentElement) {
                                    $("<div style='width:100%;height:100%;position:relative;'/>").appendTo(contentElement).dxCtrlGridFormulaire({
                                        bddCtrl: option.bddCtrl,
                                        showBtNew: false,
                                        allowClick: true,
                                        onClickDataGrid: function (container, dataGrid, dataTemplate) {
                                            var idFormulaire = dataGrid.id
                                            if (idFormulaire) {
                                                var url = option.bddCtrl.getObjet("formulaire", idFormulaire).objetMetier.mGetUrlLink()
                                                if (url.length > 0) {
                                                    dxTextBoxLink.option("value", url)
                                                    //link.link = url
                                                    //option.value = link.link
                                                    //option.onValueChanged(link)
                                                    mNotify("Vous avez inséré un lien sur un formulaire", "success", 6000)
                                                }
                                            }
                                            popupLstFormulaire.hide()
                                        }
                                    }).dxCtrlGridFormulaire("instance")
                                }
                            }).dxCtrlPopupBase("instance")
                            popupLstFormulaire.show();
                        }
                    })
                }
                Me.$DivError = $("<div style='color:red;;display:none;'>La prévisualisation ne peut-être générée. Vérifiez l'URL.</div>").appendTo($DivDetailLink)
                break;
            case "Email":
                $DivDetailLink.css("display", "")
                $("<div/>").appendTo($DivDetailLink).dxCtrlTextEmail({
                    bddCtrl: option.bddCtrl,
                    labelMode: "floating",
                    label: "Adresse email",
                    placeholder: "",
                    value: link.adrEmail,
                    onValueChanged: function (e) {
                        link.adrEmail = ((e.value == null) ? "" : e.value)
                        link.link = "mailto:" + link.adrEmail + "?subject=" + link.sujet + "&body=" + link.body
                        option.value = link.link
                        option.onValueChanged(link)
                    }
                }).dxCtrlTextEmail("instance")
                $("<br/>").appendTo($DivDetailLink)
                $("<div/>").appendTo($DivDetailLink).dxCtrlTextBox({
                    bddCtrl: option.bddCtrl,
                    labelMode: "floating",
                    label: "Objet du message",
                    value: link.sujet,
                    onValueChanged: function (e) {
                        link.sujet = ((e.value == null) ? "" : e.value.remplacerTout("&", " ").remplacerTout("?", " "))
                        link.link = "mailto:" + link.adrEmail + "?subject=" + link.sujet + "&body=" + link.body
                        option.value = link.link
                        option.onValueChanged(link)
                    }
                })
                $("<br/>").appendTo($DivDetailLink)
                $("<div/>").appendTo($DivDetailLink).dxCtrlTextBox({
                    bddCtrl: option.bddCtrl,
                    labelMode: "floating",
                    label: "Corps du message",
                    value: link.body,
                    onValueChanged: function (e) {
                        link.body = ((e.value == null) ? "" : e.value.remplacerTout("&", " ").remplacerTout("?", " "))
                        link.link = "mailto:" + link.adrEmail + "?subject=" + link.sujet + "&body=" + link.body
                        option.value = link.link
                        option.onValueChanged(link)
                    }
                })
                break;
            case "Tel.":
                $DivDetailLink.css("display", "")
                var cTel = new cTelephone(null, link.tel)
                var dataTel = cTel.mGetTelephoneDetail(link.tel)
                var dxTel = $("<div/>").appendTo($DivDetailLink).dxCtrlTelephone({
                    bddCtrl: option.bddCtrl,
                    labelMode: "floating",
                    label: "Numéro de téléphone",
                    value: dataTel,
                    onValueChanged: function (e) {
                        link.tel = e.value.tel_complet
                        link.link = "tel:" + e.value.tel_complet
                        option.value = link.link
                        option.onValueChanged(link)
                    }
                }).dxCtrlTelephone("instance")
                break;
            //case "Fichier":
            //    $DivDetailLink.css("display", "")
            //    var currentNomFileSelected = null
            //    if (link.link != "file:") {
            //        currentNomFileSelected = link.link.split(":")[1]
            //        currentNomFileSelected = decodeURI(currentNomFileSelected)
            //    }
            //    var dxFileHeberge = $("<div/>").appendTo($DivDetailLink).dxCtrlSelectEmailFileHeberge({
            //        bddCtrl: option.bddCtrl,
            //        labelMode: "floating",
            //        label: "Choisir un fichier hébergé",
            //        currentNomFileSelected: currentNomFileSelected,
            //        lstfileheberge: option.lstfileheberge,
            //        onDelete: function (e) {
            //            if (e.value != null) {
            //                option.lstfileheberge.splice(option.lstfileheberge.indexOf(e.value), 1)
            //                option.dxBuilderEmailPage.element().find("a[href='file:" + e.value + "']").each(function (idx, ele) {
            //                    $(ele).attr("href", "")
            //                })
            //                link.link = "file:"
            //                option.onValueChanged(link)
            //            }
            //        },
            //        onValueChanged: function (e) {
            //            if (e.value == null) { link.link = "file:" }
            //            else { link.link = "file:" + encodeURI(e.value.nom) }
            //            option.value = link.link
            //            option.onValueChanged(link)
            //        }
            //    }).dxCtrlSelectEmailFileHeberge("instance")
            //    break;
        }

        $("<br/>").appendTo($DivDetailLink)
        var dxTextBoxTitle = $("<div/>").appendTo($DivDetailLink).dxCtrlTextBox({
            bddCtrl: option.bddCtrl,
            labelMode: "floating",
            label: "Infobulle du lien (affiché dans vos statistiques)",
            value: link.title,
            onValueChanged: function (e) {
                link.title = ((e.value == null) ? "" : e.value)
                option.value = link.link
                option.onValueChanged(link)
            }
        }).dxCtrlTextBox("instance")

        container.css("height", "")
    }

    var link = {
        typeLink: "Aucun",
        link: "",
        adrEmail: "",
        sujet: "",
        body: "",
        tel: "",
        title: ""
    }

    function mInitTypeLink() {
        link = {
            typeLink: "Aucun",
            link: "",
            adrEmail: "",
            sujet: "",
            body: "",
            tel: "",
            title: ""
        }
        link.title = option.title || ""
        if (option.value.startsWith("javascript:void(0)")) {
            link.typeLink = "Aucun"
        } else if (option.value.startsWith("http://") || option.value.startsWith("https://") ||
            option.value.startsWith("ftp://") || option.value.startsWith("ftps://")) {
            link.link = option.value
            link.typeLink = "Web"
        } else if (option.value.startsWith("mailto:")) {
            link.typeLink = "Email"
            link.adrEmail = option.value.split("?")[0]
            link.adrEmail = link.adrEmail.replace("mailto:", "")
            var detail = option.value.split("?")[1]
            if (typeof detail == 'undefined') detail = ""
            link.sujet = detail.split("&")[0]
            link.sujet = link.sujet.replace("subject=", "")
            link.body = detail.split("&")[1]
            if (typeof link.body == "undefined") link.body = ""
            link.body = link.body.replace("body=", "")
        } else if (option.value.startsWith("tel:")) {
            link.typeLink = "Tel."
            link.tel = option.value.replace("tel:", "")
        } else if (option.value.startsWith("file:")) {
            link.link = option.value
            link.typeLink = "Fichier"
        }
    }

    this.mGetCurrentLink = function () {
        return link
    }

    this.element = function () { return container }

    mConstruit();
}